<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/1 md:w-1/1 mb-base">
        <vx-card title="Novidades do Sistema">
          <vx-timeline :data="timelineData"></vx-timeline>
        </vx-card>
      </div>
    </div>
  </div>
</template>


<script>
import VxTimeline from "@/components/timeline/VxTimeline.vue";
export default {
  components: {
    VxTimeline,
  },
  data() {
    return {
      timelineData: [
      {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Ajuste de desempenho no select de clientes",	
          desc: "Efetuado ajustes para garantir um melhor desempenho no select de clientes.",
          time: "19/06/2025",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Duplicar Solicitação de Peças",	
          desc: "Adicionado botão duplicar na Sessão Solicitação de Peças.",
          time: "19/03/2025",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Efetuado uma melhoria no ultimo preço. - Mão de Obra e Peças",	
          desc: "Agora agora ao criar um pedido e selecionar o Cliente, é mostrado o último valor pago pelo cliente se houver no item adicionado.",
          time: "21/02/2025",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Efetuado uma melhoria no ultimo preço. - Suprimentos",	
          desc: "Agora agora ao criar um pedido e selecionar o Cliente, é mostrado o último valor pago pelo cliente se houver no item adicionado.",
          time: "20/02/2025",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Efetuado uma melhoria no ultimo preço. - Equipamentos",	
          desc: "Agora agora ao criar um pedido e selecionar o Cliente, é mostrado o último valor pago pelo cliente se houver no item adicionado.",
          time: "15/01/2025",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Ultimo preço nos Pedidos de Equipamentos, Suprimentos, Mão de Obra e Peças",	
          desc: "O campo ultimo preço é visualizado e atualizado a cada intem inserido.",
          time: "11/11/2024",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Clientes - Campops Obrigatórios",	
          desc: "O campo data de fundação, ddd CPF ou CNPJ agora é obrigatório ao adicionar um novo cliente.",
          time: "23/10/2024",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Concluidos - Pedidos de Suprimentos, Peças e Mão de Obra",	
          desc: "Criado filtro onde é possível restringir a busca de pedidos Concluídos melhorando também o desempenho.",
          time: "09/10/2024",
        },
      {
          color: "warning",
          icon: "PlusIcon",
          title: "Concluidos - Pedidos de Equipamentos",	
          desc: "Criado filtro onde é possível restringir a busca de pedidos Concluídos dos Equipamentos melhorando também o desempenho.",
          time: "07/09/2024",
        },
         {
          color: "primary",
          icon: "AlertCircleIcon",
          title: "Ajuste do relatório Revisão de Equipamentos",	
          desc: "Corrigido visualização do relatório.",
          time: "15/09/2024",
        },
         {
          color: "primary",
          icon: "PlusIcon",
          title: "Usuário Ativo/Inativo",	
          desc: "Possibilitade de inativar usuários para que não listem na seleção dos pedidos.",
          time: "25/08/2024",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Anexo",	
          desc: "Anexo de arquivo nos pedidos de Equipamentos",
          time: "18/08/2024",
        },
         {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Revisão de Equipamentos",	
          desc: "Erro ao abrir revisão de Equipamentos",
          time: "05/08/2024",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Operadora de Crédito no Pedido de Equipamentos",	
          desc: "Ajuste no campo Operadora de Crédito no Pedido de Equipamentos",
          time: "16/07/2024",
        },
           {
          color: "primary",
          icon: "AlertCircleIcon",
          title: "Ajuste na Função Duplicar Pedidos",	
          desc: "Correção de Bug",
          time: "15/07/2024",
        },
         {
          color: "primary",
          icon: "PlusIcon",
          title: "Duplicar Pedidos",	
          desc: "Inserido nova funcionalidade de duplicar pedidos",
          time: "04/07/2024",
        },
         {
          color: "primary",
          icon: "PlusIcon",
          title: "Inadimplência",	
          desc: "Inserido opção de controle de inadimplência no Cadastro de Clientes",
          time: "25/10/2023",
        },
           {
          color: "primary",
          icon: "PlusIcon",
          title: "Frete",	
          desc: "Inserido opção de frete no Pedido de Equipamentos, Peças e Suprimentos",
          time: "22/12/2022",
        },
         {
          color: "primary",
          icon: "PlusIcon",
          title: "Solicação de Peças",	
          desc: "Implantação da Funcionalidade Solicitação de Peças",
          time: "21/08/2022",
        },
         {
          color: "primary",
          icon: "PlusIcon",
          title: "Confirmar ao Excluir um pedido",	
          desc: "Janela para confirmar o envio do pedido da lixeira.",
          time: "18/07/2022",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Integração das Faturas com Boletos",	
          desc: "Ao fazer o upload das faturas é indexados campos dos boletos, que posteriormente recebem informações de Pagamento de Clientes",
          time: "13/07/2022",
        },
          {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Código Ilux na seleção de cliente",
          desc: "O Código Ilux agora aparece na visualização no momento de selecionar o cliente.",
          time: "04/07/2022",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Implementado a função Cotações ",	
          desc: "O sistema agora possui a função de cotações, onde é possível cadastrar, editar e excluir cotações.",
          time: "23/05/2022",
        },
         {
          color: "primary",
          icon: "PlusIcon",
          title: "Adicionado Busca Avançada - Revisão de Equipamentos",	
          desc: "Agora é possivel buscar todos os pedidos relacionados ao produto desejado.",
          time: "12/05/2022",
        },
          {
          color: "primary",
          icon: "PlusIcon",
          title: "Adicionado Busca Avançada - Suprimentos Locação",
          desc: "Agora é possivel buscar todos os pedidos relacionados ao produto desejado.",
          time: "12/05/2022",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Adicionado Busca Avançada - Peças",
          desc: "Agora é possivel buscar todos os pedidos relacionados ao produto desejado.",
          time: "28/04/2022",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Adicionado Busca Avançada - Suprimentos",
          desc: "Agora é possivel buscar todos os pedidos relacionados ao produto desejado.",
          time: "28/04/2022",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Adicionado Busca Avançada - Equipamentos",
          desc: "Agora é possivel buscar todos os pedidos relacionados ao produto desejado.",
          time: "28/04/2022",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Campo Obrigatório Suprimentos",
          desc: "Nome do Responsável passa ser obrigatório em Suprimentos.",
          time: "11/03/2022",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Campo Obrigatório Equipamentos",
          desc: "Nome do Responsável passa ser obrigatório em Equipamentos.",
          time: "11/03/2022",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Correção Rota Pedidos Ouro",
          desc: "Correção Novo Pedido Ouro, que abrir a guia Locação.",
          time: "08/03/2022",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Novo Tipo de Pedido - Equipamentos Revisão",
          desc: "Adicionado novo tipo de pedidos.",
          time: "04/03/2022",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Correção Relatórios",
          desc: "Correção de datas nos relatórios de Equipamentos.",
          time: "23/02/2022",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Correção Etapas",
          desc: "Ajustado etapas Locação e Ouro que não apareciam na guia Concluídos",
          time: "09/12/2021",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Novos Campos - Novo Contrato e Adendo Locação e Ouro",
          desc: "Adicionado o campo Novo Contrato e Adendo nos pedidos de Locação e Ouro",
          time: "08/12/2021",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Correção Ordenação Relatório",
          desc: "Relatório Intervalo - Por Pedido ordenado por Data e não mais por ID",
          time: "30/11/2021",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Novos Campos Locação e Ouro",
          desc: "Adicionado novo campo Quantidade e meses de Contrato",
          time: "29/11/2021",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Novo Campo E-mail",
          desc: "E-mail secundario no formulário de clientes.",
          time: "05/11/2021",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Preenchimento campo email Faturas",
          desc: "Ao selecionar um cliente na criação da fatura o campo e-mail é preenchido automaticamente com o e-mail cadastrado no formulário cliente.",
          time: "04/11/2021",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Upload de Arquivo em Contratos",
          desc: "Agora é possivel anexar arquivos no Contrato.",
          time: "27/10/2021",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Correções Relatórios",
          desc: "Correções pontuais nos relátorios.",
          time: "26/10/2021",
        },
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Assinatura Fatura",
          desc: "Inserido Assinatura nas Faturas.",
          time: "25/10/2021",
        },
        /*
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Task Update Found",
          desc: "Cupcake gummi bears soufflé caramels candy",
          time: "15 Days Ago",
        },
        {
          color: "success",
          icon: "CheckIcon",
          title: "Task Finished",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 mins ago",
        },
         {
          color: "success",
          icon: "CheckIcon",
          title: "Task Finished",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 mins ago",
        }*/
      ],
    };
  },
  computed: {},

  created() {},
};
</script>
 
